export default "__VITE_ASSET__DNRKIuAu__"